export default "__VITE_ASSET__gFO$wsYTQhss$QbLyPcrAg__"